import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"

// users
import user1 from "../../../assets/images/siddhi_full_hd.png"
import Configs from "../../../config"
import secureLocalStorage from "react-secure-storage"
import ProfileModal from "./ProfileModal"

const ProfileMenu = props => {
  const [menu, setMenu] = useState(false)
  const [profileOpen, setProfileOpen] = useState(false)

  const admin_user = secureLocalStorage?.getItem("admin_user")

  const [selectedStaff, setSelectedStaff] = useState(admin_user)

  const toggleProfile = () => {
    setSelectedStaff(admin_user)
    setProfileOpen(!profileOpen)
  }

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item text-white"
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={
              admin_user?.profilePicture
                ? `${Configs.imageUrl}${admin_user?.profilePicture}`
                : user1
            }
            alt="Header Avatar"
          />

          <span className="d-none d-xl-inline-block ms-2 me-1 fw-bold fs-6 text-dark">
            {admin_user?.name || "Admin"}
          </span>

          <i className="mdi mdi-chevron-down d-none d-xl-inline-block text-dark fs-6 fw-bold" />
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem onClick={toggleProfile}>
            <i className="bx bx-user font-size-16 align-middle me-1" />
            Profile
          </DropdownItem>

          <div className="dropdown-divider" />

          <Link to={`${Configs.appurl}login`} className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            Logout
          </Link>
        </DropdownMenu>
      </Dropdown>
      <ProfileModal
        open={profileOpen}
        toggle={toggleProfile}
        selectedStaff={selectedStaff}
        setSelectedStaff={setSelectedStaff}
        profileMode={true}
      />
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
}

export default ProfileMenu
